import toast from "react-hot-toast";
import logo from "assets/images/sitelogo.svg";
export default function toastFunction(type, text) {
  // toast[type](
  //   <p className="text-center">
  //     <div>
  //       <img src={logo} style={{ width: "50px" }} />
  //     </div>
  //     {text}
  //   </p>
  // );

  toast[type](
    <div
      className="d-flex  "
      style={{
        backgroundColor: "white",
        borderRadius: "10px",
        boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
        padding: "10px",
      }}
    >
      <div>
        <img style={{ width: "40px" }} src={logo}></img>
      </div>
      <div style={{ alignSelf: "center", marginRight: "5px" }}>{text}</div>
    </div>,
    { duration: 4000 }
  );
}
